import React, { useEffect } from "react";
import { Row, Col, CardTitle } from "reactstrap";
import ComponentCard from "./ComponentCard";

const LearningResources = () => {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="page-wrapper overflow-hidden">
      <div align="center" style={{ paddingTop: "0px" }}>
        <Row
          className="justify-content-center"
          style={{ margin: "0 auto", maxWidth: "1200px" }}
        >
          <Col sm="12" md="12">
            <ComponentCard>
              <div
                style={{
                  maxWidth: "1000px",
                  minHeight: "300px",
                  margin: "0 auto",
                  marginTop: "10px",
                }}
              >
                <CardTitle
                  tag="h4"
                  style={{ fontWeight: "bold", marginBottom: "20px" }}
                >
                  Learning Resources
                </CardTitle>

                {/* Add Content here */}
              </div>
            </ComponentCard>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LearningResources;
